import React from 'react';
import {login} from '../../services/dataService';
import DevRecipientSelection from './DevRecipientSelection'


const Login =({location}) => {
    
  const urlParamFind = location.search.split("ReturnUrl=");
  const returnUrl = urlParamFind.length ===2 ? urlParamFind[1]: "";

    return (

      <div className="login-dev-wrapper fadeInDown">
        <div className="login-form-content">

          <form>
            <h4 className="login-dev-welcome">
              Correspondence System Developer Login Shim
            </h4>
            <b>
              Please choose login to emulate:
            </b>
            <div style={{margin:"20px"}}>
              <DevRecipientSelection handleUserSelected={handleLoggedIn} returnUrl={returnUrl} ></DevRecipientSelection>
            </div>
                      
          </form>

        </div>
      </div>

    )    
}

const handleLoggedIn = async (userInfo, returnUrl)=>{
  if(userInfo && userInfo.userName){
    await login(userInfo.userName);      
    window.location=returnUrl;  
  }  
}

export default Login
